import React, { memo } from 'react'
import { UseFormMethods } from 'react-hook-form'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles } from 'transfix-ui/core/styles'
import { TEST_IDS } from '../../constants'
import { TCarrierOptionSchema } from '../../schema'

const useCarrierOptionFormFooterStyles = makeStyles(theme => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
  submitButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export interface ICarrierOptionFormFooterProps
  extends Pick<UseFormMethods<TCarrierOptionSchema>, 'control'> {
  isEditing: boolean
  loading: boolean
  onCancel: () => void
  onSubmit: () => void
}

const CarrierOptionFormFooter = memo<ICarrierOptionFormFooterProps>(
  ({ control, isEditing, loading, onCancel, onSubmit }) => {
    const classes = useCarrierOptionFormFooterStyles()

    const showGetApprovalCheckbox = !isEditing

    return (
      <div className={classes.footer}>
        <div>
          <Button
            color='tertiary'
            data-test={TEST_IDS.cancelButton}
            onClick={onCancel}
            disabled={loading}>
            Cancel
          </Button>
        </div>
        <div className={classes.submitButtonWrapper}>
          {showGetApprovalCheckbox && (
            <div>
              <ControlledCheckbox
                control={control}
                name='getApproval'
                CheckboxProps={{
                  label: 'Get Approval',
                  dataTest: TEST_IDS.getApprovalCheckbox,
                }}
              />
            </div>
          )}
          <div>
            <Button
              color='primary'
              size='large'
              data-test={TEST_IDS.submitButton}
              onClick={onSubmit}
              disabled={loading}>
              {isEditing ? 'Edit Carrier Option' : 'Add Option'}
            </Button>
          </div>
        </div>
      </div>
    )
  }
)

export default CarrierOptionFormFooter
